import { css } from 'styled-components';

export default css`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  grid-gap: 10px;
  margin-bottom: 10px;
`;
